import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { serverTimestamp } from 'firebase/firestore';
import { EncuestaFinal } from 'src/app/shared/components/dialog/models/encuesta-final';
import { CabeceraRespuesta } from 'src/app/shared/components/formularios-encuesta/models/cabecera-respuesta';
import { CEncuesta } from 'src/app/shared/components/formularios-encuesta/models/encuesta.model';
import { RespuestaFormulario } from 'src/app/shared/components/formularios-encuesta/models/respuesta-formulario';
import { colections, documentEncuesta, documentRespuestaFormulario } from 'src/app/shared/cons/db.colections';
import { Utils } from 'src/app/shared/helpers/utils';
import { TransaccionModel } from 'src/app/shared/services/models/trasaccion.model';

@Injectable({
  providedIn: 'root'
})
export class EncuestaDaService {
  transaccion: TransaccionModel = new TransaccionModel();
  constructor(
    private db: AngularFirestore,
  ) { }

  async getFormularioExternoRespuesta(codigoFormulario: string, fechaInicial:Date, fechaFinal:Date):Promise<CabeceraRespuesta[] | null> {
    let encuestaFinal: EncuestaFinal | null = new EncuestaFinal();

      const formularioRef = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL, ref =>
        ref.where(documentEncuesta.ENCABEZADO_CODIGO_ENCUESTA, '==', codigoFormulario)
          .where(documentEncuesta.ES_PUBLICADO,'==',true)
          .where(documentEncuesta.ES_BORRADO,'==',false));
      const respuestaForm = await formularioRef.get().toPromise();
      let idEncuestaExterno:string |null=null;
      let formularioCompleto: EncuestaFinal = new EncuestaFinal();
      if(!respuestaForm.empty){
        idEncuestaExterno =  respuestaForm.docs[0].id;
        formularioCompleto = respuestaForm.docs[0].data() as EncuestaFinal;
        formularioCompleto.id = respuestaForm.docs[0].id;
      }
      else{
        return null;
      }
      
      const listaRspta = formularioRef.doc(idEncuestaExterno).collection(colections.RESPUESTA_FORMULARIO, ref1=>
          ref1.where(documentRespuestaFormulario.FECHA_CREACION,'>=', fechaInicial )
          .where(documentRespuestaFormulario.FECHA_CREACION,'<=', fechaFinal )).get().toPromise();
      const rstas = await listaRspta;
      let listaRespuesta: CabeceraRespuesta[] =  [];
      if(!rstas.empty){
        rstas.forEach(rs=>{
          const data = rs.data() as CabeceraRespuesta;
          data.id = rs.id;
          data.fecha_creacion = data.fecha_creacion.toDate();
          data.formulario = formularioCompleto;
          listaRespuesta.push(data);
        })
      }
      else{
        return null;
      }    
      return listaRespuesta;
    }

   async getCartaExterno(rutaParcial: string):Promise<EncuestaFinal | null> {
    let encuestaFinal: EncuestaFinal | null = new EncuestaFinal();

      const formularioRef = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL, ref =>
        ref.where(documentEncuesta.RUTA_PARCIAL, '==', rutaParcial)
          .where(documentEncuesta.ES_PUBLICADO,'==',true)
          .where(documentEncuesta.ES_BORRADO,'==',false).limit(1));
      
      const listaEncuesta = await formularioRef.get().toPromise();
      if(!listaEncuesta.empty){
        encuestaFinal = (listaEncuesta.docs[0].data()) as EncuestaFinal;
        encuestaFinal.id = listaEncuesta.docs[0].id;
      }
      else{
        encuestaFinal = null;
      }    
      return encuestaFinal;
    }

    insertEncuesta(idEncuesta: string, listaRespuesta: CabeceraRespuesta) {
      const formularioRef = this.db
        .collection(colections.EXTERNO_ENCUESTA_DIGITAL)
        .doc(idEncuesta)
        .collection(colections.RESPUESTA_FORMULARIO);
    
      const docListaRespuestas = Utils.SerializeJsonToDb(listaRespuesta);
      docListaRespuestas.fecha_creacion = serverTimestamp();
    
      const newDocRef = formularioRef.doc(); // Generar un doc con ID aleatorio
    
      return newDocRef.set(docListaRespuestas).then(() => {
        return this.transaccion.tx = true;
      }).catch(error=>{
        this.transaccion.error = error;
        return this.transaccion.tx = false;
      });
    }
    
    
}
